<nav class="nav" [ngClass]="css">
  <ng-content></ng-content>
</nav>
